import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { CostPackageDetailList, CostPackageItemTable } from "../components";
import * as costpackage from "../redux";

export class CostpackageDetail extends Component {
    componentDidMount() {
        const { costpackageID, getDetail } = this.props;
        getDetail(costpackageID);
    }

    render() {
        const { costpackage, loading, extraProps } = this.props;
        const base_op = {
            className: "costpackage_list",
            // title: 'Cost package Management',
            breadcrumbs: [
                { name: "Home", rel: "/", icon: "home" },
                { name: "Cost Package Management", rel: "/costpackage/" },
                { name: `Cost Package ${costpackage ? costpackage.code : ""}` }
            ],
            extraProps,
            loading
        };

        return (
            <Base {...base_op}>
                <CostPackageDetailList costpackage={costpackage} />
                <CostPackageItemTable items={costpackage ? costpackage.sales_items : []} />
            </Base>
        );
    }
}

const mapStateToProps = (store, ownProps) => {
    return {
        costpackage: store.costpackage.costpackage,
        costpackageID: ownProps.match.params.cpID,
        loading: store.costpackage.loading,
        loaded: store.costpackage.loaded
    };
};

const mapDispatchToProps = dispatch => ({
    getDetail: cp_id => dispatch(costpackage.actions.getCostpackageDetail(cp_id))
});

export default connect(mapStateToProps, mapDispatchToProps)(CostpackageDetail);
